module.exports = __webpack_public_path__ + "static/img/CHARGE_ESSENTIAL.8d7dc90f.jpg";